<div [ngClass]="mergedClass" [ngStyle]="style">
  <div [ngClass]="mergedLabelClass">
    {{ label }}
  </div>
  <!--  Only slideText if 'value' is not array because it is a bit buggy-->
  <div [ngClass]="mergedValueClass" slideText [animateText]="animateText && !isArray(value)">
    <span (click)="$event.preventDefault(); onValueClick()" [ngClass]="textValueClass"> {{ isArray(value) ? value.join('\n') : value }}</span>

    <ng-content />
  </div>
</div>
